module.exports = __webpack_public_path__ + "e3a8152394366632f4e5428a07a23de5.png";